// @flow
import React, { Component, type ComponentType } from "react";

import InternalDialog from "./InternalDialog";

type Props = {|
    onHide: Function,
    children: ComponentType<any>,
    open: boolean,
    showCloseButton: boolean
|};

class Dialog extends Component<Props> {
    render() {
        const { open, showCloseButton, children } = this.props;
        return open ? (
            <InternalDialog showCloseButton={showCloseButton} {...this.props}>
                {children}
            </InternalDialog>
        ) : (
            <div />
        );
    }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/dialog/view.js